// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"651":"eaa1a66b","686":"17709acd","858":"8d3eb382"}[chunkId] + ".chunk.js";
};